import { connect } from 'react-redux';
import App from './App.jsx';
import { loadGravestones } from './store/actions';
import { showInset } from './store/selectors';

const mapStateToProps = state => ({
  selectedGravestone: state.selectedGravestone,
  aboutOpen: state.aboutOpen,
  contactUsOpen: state.contactUsOpen,
  showInset: showInset(state),
});

const mapDispatchToProps = dispatch => ({
  loadGravestones: () => dispatch(loadGravestones()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js